import { useQuery } from "@tanstack/react-query"
import { getBackofficeOrganizationsQuery } from "modules/backoffice/lib/organizations/getBackofficeOrganizationsQuery"

export function useGetBackofficeOrganizationsQuery(
  ...args: Parameters<typeof getBackofficeOrganizationsQuery>
) {
  return useQuery(getBackofficeOrganizationsQuery(...args))
}
